import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { useMemo } from "react";
import { TenantCategory } from "types/enums";

export const useTenantCategorySelectOptions = () => {
    const { t } = usePaldockTranslation("general.tenant_category");

    const options = useMemo(
        () =>
            Object.values(TenantCategory).map((value) => ({
                label: t(value),
                value: value,
            })),
        [t]
    );

    return { options, loading: false, error: null };
};
